/* ============================================================
   eco-cyborg.js
   TwoCan — Eco-Cyborg Loyalty Programme
   Vanilla JS — no dependencies. ES5-compatible.
   ============================================================ */

(function () {
  'use strict';

  /* ── Dividend bar animation ──────────────────────────────── */
  function initDividendBars() {
    var bars = document.querySelectorAll('.ec-bar[data-height]');
    if (!bars.length) return;
    bars.forEach(function (bar, i) {
      var target = bar.getAttribute('data-height') || '0';
      setTimeout(function () {
        bar.style.height = target;
      }, 150 + i * 100);
    });
  }

  /* ── Bid modal ───────────────────────────────────────────── */
  function initBidButtons() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.ec-bid-trigger');
      if (!trigger) return;
      e.preventDefault();
      var seat     = trigger.getAttribute('data-seat')      || '—';
      var askPrice = trigger.getAttribute('data-ask-price') || '—';
      var bids     = trigger.getAttribute('data-bids')      || '0';
      var table    = trigger.closest('[data-bid-email]');
      var email    = table ? table.getAttribute('data-bid-email') : '';
      openBidModal(escapeHtml(seat), escapeHtml(askPrice), escapeHtml(bids), email);
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openBidModal(seat, askPrice, bids, email) {
    closeModal();

    var overlay = document.createElement('div');
    overlay.className = 'ec-bid-overlay';
    overlay.id = 'ec-bid-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Place a bid for seat ' + seat);

    overlay.innerHTML =
      '<div class="ec-bid-modal">' +
        '<button class="ec-bid-modal__close" aria-label="Close">&times;</button>' +
        '<div class="ec-bid-modal__seat">SEAT #' + seat + '</div>' +
        '<div class="ec-bid-modal__label">Membership Market — Place a bid</div>' +
        '<div class="ec-bid-modal__price-row"><span>Asking price</span><span>' + askPrice + '</span></div>' +
        '<div class="ec-bid-modal__price-row"><span>Current bids</span><span>' + bids + '</span></div>' +
        '<hr class="ec-bid-modal__divider">' +
        '<input type="text" id="ec-bid-amount" placeholder="Your bid (e.g. R 5,200)" autocomplete="off">' +
        '<input type="text" id="ec-bid-alias"  placeholder="Your member alias (e.g. Member #47)" autocomplete="off">' +
        '<button class="ec-bid-modal__submit" id="ec-bid-submit">Submit bid</button>' +
        '<p class="ec-bid-modal__note">Bids are reviewed by TwoCan. Successful bids are confirmed by email within 48 hours.</p>' +
      '</div>';

    document.body.appendChild(overlay);

    /* Close handlers */
    overlay.querySelector('.ec-bid-modal__close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', escHandler);

    /* Submit */
    overlay.querySelector('#ec-bid-submit').addEventListener('click', function () {
      var amount = overlay.querySelector('#ec-bid-amount').value.trim();
      var alias  = overlay.querySelector('#ec-bid-alias').value.trim();
      if (!amount) {
        overlay.querySelector('#ec-bid-amount').focus();
        return;
      }
      /* Bids are sent to TwoCan by email (membership_email section setting) */
      if (email) {
        window.location.href = 'mailto:' + email +
          '?subject=' + encodeURIComponent('Eco-Cyborg Bid — Seat #' + seat) +
          '&body=' + encodeURIComponent('Seat: #' + seat + '\nMy bid: ' + amount + '\nMember alias: ' + alias);
      }
      showModalSuccess(overlay, seat, escapeHtml(amount));
    });

    /* Focus trap */
    overlay.querySelector('#ec-bid-amount').focus();
  }

  function showModalSuccess(overlay, seat, amount) {
    var modal = overlay.querySelector('.ec-bid-modal');
    modal.innerHTML =
      '<button class="ec-bid-modal__close" aria-label="Close">&times;</button>' +
      '<div class="ec-bid-success">' +
        '<div class="ec-bid-success__icon">✓</div>' +
        '<div class="ec-bid-success__title">Almost done</div>' +
        '<div class="ec-bid-success__body">' +
          'Your email app has opened with your bid of <strong>' + amount + '</strong> for Seat #' + seat + '.<br>' +
          'Send that email to submit it. TwoCan will review and confirm within 48 hours.' +
        '</div>' +
      '</div>';
    modal.querySelector('.ec-bid-modal__close').addEventListener('click', closeModal);
  }

  function escHandler(e) {
    if (e.key === 'Escape') closeModal();
  }

  function closeModal() {
    var existing = document.getElementById('ec-bid-modal');
    if (existing) {
      existing.remove();
      document.removeEventListener('keydown', escHandler);
    }
  }

  /* ── News tag filter ─────────────────────────────────────── */
  function initNewsFilter() {
    var chips = document.querySelectorAll('.ec-tag-chip[data-filter]');
    if (!chips.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-filter');

        chips.forEach(function (c) { c.classList.remove('ec-tag-chip--active'); });
        chip.classList.add('ec-tag-chip--active');

        var rows = document.querySelectorAll('.ec-news-row[data-tag]');
        rows.forEach(function (row) {
          if (filter === 'all' || row.getAttribute('data-tag') === filter) {
            row.removeAttribute('hidden');
          } else {
            row.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  /* ── Scroll fade ─────────────────────────────────────────── */
  function initScrollFade() {
    var els = document.querySelectorAll('.ec-fade');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ec-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(function (el) { observer.observe(el); });
    } else {
      /* Fallback: show all */
      els.forEach(function (el) { el.classList.add('ec-visible'); });
    }
  }

  /* ── Boot ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initDividendBars();
    initBidButtons();
    initNewsFilter();
    initScrollFade();
  });

}());
